import React, { Component } from "react";
import logo from "../images/boem_logo.avif";
import { Modal, fixedBody } from "../helpers/Modal";
import ImprintModal from "../helpers/ImprintModal";
import DataPrivacyModal from "../helpers/DataPrivacyModal";

class Footer extends Component {  
  state = {
  showModalImprint: false,
  showModalDataPrivacy: false,
};

toggleModal = (show, modal) => {
  this.setState({ [modal]: show });
  let bodyToggle = show ? "hidden" : "visible";
  fixedBody(bodyToggle);
};

  render() {
    return (<>
      <footer className="footer">
        <img src={logo} alt="Hand-drawn illustration of Bandit the chinchilla sitting behind a small laptop" />
        <div>Made with <i className="fa fa-heart"/> by <a href="https://anja.codes">anja.codes</a>
        </div>
        <div className="social-btns">
            <a href="https://www.facebook.com/chaoschinchillas/" className="social-link"><i className="fab fa-facebook" /></a>
            <a href="https://www.instagram.com/chaos_chinchillas/" className="social-link"><i className="fab fa-instagram" /></a>
        </div>
        <div className="footer-btns">
          <button onClick={() => this.toggleModal(true, "showModalImprint")}>Copyright</button> | 
          <button onClick={() => this.toggleModal(true, "showModalDataPrivacy")}>Privacy Policy</button>
          </div>
      </footer>


<Modal
isShown={this.state.showModalImprint}
hide={() => this.toggleModal(false, "showModalImprint")}
modalContent={<ImprintModal />}
headerText={"Copyright"}
/>

<Modal
isShown={this.state.showModalDataPrivacy}
hide={() => this.toggleModal(false, "showModalDataPrivacy")}
modalContent={<DataPrivacyModal />}
headerText={"Privacy Policy"}
/>
</>
    );
  }
}

export default Footer;
